import React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from '@saucelabs/ds-typography';
import { constants as appStorageConstants } from '@saucelabs/sl-module-app-storage';

import Audio from './Audio';
import Language from './Language';
import Orientation from './Orientation';
import Proxy from './Proxy';
import Passcode from './Passcode';
import Resigning from './Resigning';
import Instrumentation from './Instrumentation';
import { selectors as groupSelectors } from '../../group';

const { APP_STORAGE_KIND } = appStorageConstants;

const Settings: React.FC = () => {
  const kind = useSelector(groupSelectors.currentGroupKindSelector);

  return (
    <div className="m-2 px-3 pb-2 pt-0.25 bg-gray-50">
      <Typography
        variant="heading-4"
      >
        Real Device Settings
      </Typography>

      <Typography>
        Changing application settings will affect all uploaded versions of the application.
        {' '}
        These settings apply only to real devices!
      </Typography>

      <div className="flex flex-col mt-5 md:flex-row">
        <div className="w-full max-w-50 mr-10">
          <div className="mb-1">
            <Language />
          </div>

          <div className="mb-1">
            <Orientation />
          </div>

          <Proxy />
        </div>
        <div className="w-full max-w-37 mt-2 md:mt-0">
          <div className="mb-1">
            <Passcode />
          </div>

          <div className="mb-1">
            <Audio />
          </div>

          { kind === APP_STORAGE_KIND.IOS && (
            <Resigning />
          )}

          { kind === APP_STORAGE_KIND.ANDROID && (
            <Instrumentation />
          )}
        </div>
      </div>
    </div>
  );
};

export default Settings;
